






























































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";
import GapEditor from "@/components/gap/GapEditor.vue";

@Component({
  components: {
    BPopover,
    GapEditor,
  },
  computed: mapState("schedule", ["typeStatus"]),
})
export default class GapsPopover extends Vue {
  @Prop() readonly appt!: any;
  id = "patient-gaps-popover";
  gaps: Array<any> = [];
  loading = false;
  get target() {
    return this.id + "-target-" + this.appt.id;
  }
  async getGaps() {
    this.loading = true;
    try {
      this.gaps = await this.$store.dispatch(
        "schedule/getPatientGapList",
        this.appt.patientId
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  close() {
    if (this.loading) return;
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    this.getGaps();
  }
}
